import loadable from '@loadable/component';

const FacilitiesPage = loadable(() => import('./page'));
const FacilityDashboardPage = loadable(() => import('./[id]/page'));

export const routes = [
  {
    path: '',
    element: <FacilitiesPage />,
  },
  {
    path: ':id',
    element: <FacilityDashboardPage />,
  },
];
